import type { i18nStringType } from "i18n/i18nString";

const SHIPPING_STATUS_LABELS: Record<string, i18nStringType> = {
  packing: "settlementHistory.shippingStatus.packing",
  shipped: "settlementHistory.shippingStatus.shipped",
  cancelled: "settlementHistory.shippingStatus.cancelled",
  suspended: "settlementHistory.shippingStatus.suspended",
};

export const getShippingStatusLabel = (status: string): i18nStringType => {
  return (
    SHIPPING_STATUS_LABELS[status] ?? "settlementHistory.shippingStatus.unknown"
  );
};
